export enum ClarityEvent {
    AMELIA_OPEN = 'amelia-open',
    AMELIA_WIDGET_SETTINGS_ERROR = 'amelia-widget-settings-error',
    CART_AND_OPTIONS_ERROR_MESSAGE = 'cart-and-options-error-message',
    CHECKOUT_ADDON_SEATING = 'checkout-addon-seating',
    CHECKOUT_ADDON_SEATING_ERROR = 'checkout-addon-seating-error',
    CHECKOUT_ADDON_SEATING_GORDIAN = 'checkout-addon-seating-gordian',
    CHECKOUT_ADDON_SEATING_GORDIAN_ERROR = 'checkout-addon-seating-gordian-error',
    CHECKOUT_ADDON_SEATING_GORDIAN_SEAT_CHANGED = 'checkout-addon-seating-gordian-seats-changed',
    CHECKOUT_ADDON_TRANSFER = 'checkout-addon-transfer',
    CHECKOUT_ADDON_TRANSFER_ADDED = 'checkout-addon-transfer-added',
    CHECKOUT_ADDON_WARNING = 'checkout-addon-warning',
    CHECKOUT_BAGGAGE_WARNING = 'checkout-baggage-warning',
    CHECKOUT_CART_EXPIRED = 'checkout-cart-expired',
    CHECKOUT_COPY_FLIGHT = 'checkout-copy-flight',
    CHECKOUT_COPY_FLIGHT_ERROR = 'checkout-copy-flight-error',
    CHECKOUT_COPY_FERRY = 'checkout-copy-ferry',
    CHECKOUT_COPY_FERRY_ERROR = 'checkout-copy-ferry-error',
    CHECKOUT_COPY_HOTEL = 'checkout-copy-hotel',
    CHECKOUT_COPY_HOTEL_ERROR = 'checkout-copy-hotel-error',
    CHECKOUT_DISCOUNT_CODE_OPEN = 'checkout-discount-code-open',
    CHECKOUT_IMPORTANT_NOTES_OPEN = 'checkout-important-notes-open',
    CHECKOUT_PAGE_VIEW = 'checkout-page-view',
    CHECKOUT_PAYMENT_ERROR = 'checkout-payment-error',
    CHECKOUT_PRICE_BREAKDOWN_DETAILS_OPEN = 'checkout-price-breakdown-details-open',
    CHECKOUT_PRODUCT_ACTIVITY = 'checkout-product-activity',
    CHECKOUT_PRODUCT_FERRY = 'checkout-product-ferry',
    CHECKOUT_PRODUCT_FLIGHT = 'checkout-product-flight',
    CHECKOUT_PRODUCT_FLIGHT_RYANAIR = 'checkout-product-flight-ryanair',
    CHECKOUT_PRODUCT_HOTEL = 'checkout-product-hotel',
    CHECKOUT_REMOVE_PRODUCT_ERROR = 'checkout-remove-product-error',
    CHECKOUT_RYANAIR_BOOKING_PROCESS = 'checkout-ryanair-booking-process',
    CHECKOUT_SEMBONUS_AUTHORIZED = 'checkout-sembonus-authorized',
    CHECKOUT_SEMBONUS_NOT_ELIGIBLE = 'checkout-sembonus-not-eligible',
    CHECKOUT_SEMBONUS_UNAUTHORIZED = 'checkout-sembonus-unauthorized',
    CHECKOUT_SERVICE_PACKAGE_PREMIUM_SELECTED = 'checkout-service-package-premium-selected',
    CHECKOUT_SERVICE_PACKAGE_VALIDATION_ERROR = 'checkout-service-package-validation-error',
    CHECKOUT_SERVICE_PACKAGE_WARNING = 'checkout-service-package-warning',
    CHECKOUT_SERVER_VALIDATION_ERROR = 'checkout-server-validation-error',
    CHECKOUT_TRAVELLER_SECTION = 'checkout-traveller-section',
    CHECKOUT_DUPLICATE_PAX_WARNING = 'checkout-duplicate-pax-warning',
    META_FLIGHT_LANDING_INITIAL_ERROR = 'meta-flight-landing-initial-error',
    META_FLIGHT_LANDING_NO_FLIGHTS = 'meta-flight-landing-no-flights',
    META_FLIGHT_LANDING_PAGE_VIEW = 'meta-flight-landing-page-view',
    MY_BOOKING_CANCELLED_VIEW = 'my-booking-cancelled-view',
    MY_BOOKING_COUPON_FLIGHT = 'my-booking-coupon-flight',
    MY_BOOKING_INITIAL_ERROR = 'my-booking-initial-error',
    MY_BOOKING_MODAL_PACKAGE_RULES = 'my-booking-modal-package-rules',
    MY_BOOKING_PAGE_VIEW = 'my-booking-page-view',
    MY_BOOKING_PAYMENT_MODAL = 'my-booking-payment-modal',
    MY_BOOKING_PRODUCT_ACTIVITY = 'my-booking-product-activity',
    MY_BOOKING_PRODUCT_FERRY = 'my-booking-product-ferry',
    MY_BOOKING_PRODUCT_FLIGHT = 'my-booking-product-flight',
    MY_BOOKING_PRODUCT_FLIGHT_RYANAIR = 'my-booking-product-flight-ryanair',
    MY_BOOKING_PRODUCT_GOLF = 'my-booking-product-golf',
    MY_BOOKING_PRODUCT_HOTEL = 'my-booking-product-hotel',
    MY_BOOKING_PRODUCT_TRANSFER = 'my-booking-product-transfer',
    MY_BOOKING_RYANAIR_VERIFICATION = 'my-booking-ryanair-verification',
    MY_BOOKING_RYANAIR_VERIFICATION_EXPIRED = 'my-booking-ryanair-verification-expired',
    MY_BOOKING_RYANAIR_VERIFICATION_LOADING = 'my-booking-ryanair-verification-loading',
    MY_BOOKING_SESSION_INITIAL_ERROR = 'my-booking-session-initial-error',
    MY_BOOKING_SESSION_SAVE_SESSION_FERRY_ERROR = 'my-booking-session-save-session-ferry-error',
    MY_BOOKING_SPOTLIGHTS_REARRANGE = 'my-booking-spotlights-rearrange',
    MY_BOOKING_UPSELL_BAGGAGE = 'my-booking-upsell-baggage',
    MY_BOOKING_UPSELL_FERRY = 'my-booking-upsell-ferry',
    MY_BOOKING_UPSELL_HOTEL = 'my-booking-upsell-hotel',
    MY_BOOKING_UPSELL_RENTAL_CAR = 'my-booking-upsell-rentalCar',
    MY_BOOKING_UPSELL_SEATING = 'my-booking-upsell-seating',
    MY_BOOKING_UPSELL_SERVICE_PACKAGE = 'my-booking-upsell-servicePackage',
    MY_BOOKING_UPSELL_TICKETS = 'my-booking-upsell-tickets',
    MY_BOOKING_UPSELL_TRANSFER = 'my-booking-upsell-transfer',
    MY_BOOKINGS_PAGE_VIEW = 'my-bookings-page-view',
    PAYMENT_PAGE_VIEW = 'payment-page-view',
    POST_CHECKOUT_PAGE_VIEW = 'post-checkout-page-view',
    POST_CHECKOUT_SERVER_VALIDATION_ERROR = 'post-checkout-server-validation-error',
    PRE_CHECKOUT_INITIAL_ERROR = 'pre-checkout-initial-error',
    PRE_CHECKOUT_NO_PRODUCTS_ERROR = 'pre-checkout-no-products-error',
    PRE_CHECKOUT_OPTION_ERRORS = 'pre-checkout-option-errors',
    PRE_CHECKOUT_PAGE_VIEW = 'pre-checkout-page-view',
    PRE_CHECKOUT_SAVE_SELECTIONS_ERROR = 'pre-checkout-save-selections-error',
    REDIRECT_PAGE_VIEW = 'redirect-page-view',
    SITENEO_UNHANDLED_ERROR = 'siteneo-unhandled-error',
}
